import { PMG_CONSTANTS, STATUS } from "../constant";

const initState = {
  data: null,
  decisionData: null,
  isApiLoading: null,
  headingDetailsData: {},
  headingSelectedTab: "PMG Invest India",
  pmgList: {}
};
export default function pmgReducer(state = initState, action) {
  switch (action.type) {
    case PMG_CONSTANTS.PMG_FORM_START:
    case PMG_CONSTANTS.PMG_FORM_GET_START:
    case PMG_CONSTANTS.PMG_FORM_UPDATE_START:
    case PMG_CONSTANTS.PMG_UPDATE_ADD_START:
    case PMG_CONSTANTS.PMG_UPDATE_GET_START:
    case PMG_CONSTANTS.PMG_UPDATE_EDIT_START:
      return { ...state, isApiLoading: STATUS.LOADING };

    case PMG_CONSTANTS.HEADING_DETAILS_SUCCESS:
      return {
        ...state,
        headingDetailsData: action.payload
      };

    case PMG_CONSTANTS.HEADING_SELECTED_TAB:
      return {
        ...state,
        headingSelectedTab: action.payload
      };

    case PMG_CONSTANTS.PMG_FORM_SUCCESS:
    case PMG_CONSTANTS.PMG_FORM_GET_SUCCESS:
    case PMG_CONSTANTS.PMG_FORM_UPDATE_SUCCESS:
    case PMG_CONSTANTS.PMG_UPDATE_ADD_SUCCESS:
    case PMG_CONSTANTS.PMG_UPDATE_GET_SUCCESS:
    case PMG_CONSTANTS.PMG_UPDATE_EDIT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        pmgStatus: STATUS.SUCCESS
      };

    case PMG_CONSTANTS.PMG_FORM_FAILURE:
    case PMG_CONSTANTS.PMG_FORM_GET_FAILURE:
    case PMG_CONSTANTS.PMG_FORM_UPDATE_FAILURE:
    case PMG_CONSTANTS.PMG_UPDATE_ADD_FAILURE:
    case PMG_CONSTANTS.PMG_UPDATE_GET_FAILURE:
    case PMG_CONSTANTS.PMG_UPDATE_EDIT_FAILURE:
      return { ...state, pmgStatus: STATUS.ERROR };
    case PMG_CONSTANTS.PMG_LIST_DATA_SUCCESS:
      return {
        ...state,
        pmgList: action.payload
      };
    default:
      return state;
  }
}
